import React from "react";
import { Container, Box, Typography, Breadcrumbs, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";

import SyllabusSection from "./components/syllabus_component"; // adjust path
import { alpha } from "@mui/material/styles";
import { red, orange } from "@mui/material/colors";
import Header from "./header";
import Footer from "./footer";
import { Helmet } from "react-helmet-async";
import Seo from "./components/Seo";
import seoRoutes from "../seo/seoRoutes";
const ORANGE_ACCENT = orange?.A400 || orange[600] || "#ff9100";

// Reusable header-like background (matches your hero/header)
const headerLikeBg = {
  position: "relative",
  overflow: "hidden",
  backgroundImage: `linear-gradient(135deg, ${alpha(red[600], 0.08)} 0%, ${alpha(
    ORANGE_ACCENT,
    0.08
  )} 100%)`,
  border: (t) => `1px solid ${t.palette.divider}`,
  "&:before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage:
      "radial-gradient(rgba(255,255,255,.16) 1px, transparent 1.5px)", //update
    backgroundSize: "14px 14px",
    pointerEvents: "none",
  },
};


export default function SyllabusPage() {
  const seo = seoRoutes["/syllabus"];
  return (
   <>
   <Seo title={seo.title} description={seo.description} path="/syllabus" image={seo.image} />

    <Header />
   
         {/* HERO */}
         <Box
           sx={{
             pt: { xs: 7, sm: 9 },
             pb: { xs: 5, sm: 7 },
             backgroundImage: `linear-gradient(135deg, ${alpha(
               red[600],
               0.10
             )} 0%, ${alpha(ORANGE_ACCENT, 0.10)} 100%)`,
             borderBottom: `1px solid ${alpha(red[600], 0.18)}`,
             position: "relative",
             overflow: "hidden",
             "&:after": {
               content: '""',
               position: "absolute",
               inset: 0,
               background:
                 `radial-gradient(420px 260px at 0% 0%, ${alpha("#fff", .18)} 0%, transparent 60%),
                  radial-gradient(460px 280px at 100% 100%, ${alpha("#fff", .10)} 0%, transparent 65%)`,
               pointerEvents: "none",
             },
           }}
         >
           <Container maxWidth="lg">
             <Typography
               component="h1"
               align="center"
               sx={{
                 fontWeight: 900,
                 // Bigger, fluid title
                 fontSize: "clamp(32px, 5vw, 56px)",
                 lineHeight: 1.12,
                 letterSpacing: 0.2,
                 background: `linear-gradient(90deg, ${red[700]} 0%, ${ORANGE_ACCENT} 100%)`,
                 WebkitBackgroundClip: "text",
                 backgroundClip: "text",
                 color: "transparent",
               }}
             >
               Class 11 & 12 subject-wise Syllabus
             </Typography>
           </Container>
         </Box>
    <Box sx={{ py: { xs: 2, sm: 3 } }}>
      <Container maxWidth="lg">
        {/* Top header */}
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box>
            <Breadcrumbs sx={{ mb: 1, fontSize: 13 }}>
              <Link
                component={RouterLink}
                to="/"
                underline="hover"
                color="inherit"
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <HomeRoundedIcon sx={{ fontSize: 18 }} /> Home
              </Link>
              <Typography
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
                color="text.primary"
              >
                <MenuBookRoundedIcon sx={{ fontSize: 18 }} />
                Syllabus
              </Typography>
            </Breadcrumbs>

            <Typography sx={{ fontWeight: 900, fontSize: { xs: 22, sm: 28 } }}>
              Syllabus Downloads
            </Typography>
            <Typography sx={{ mt: 0.5, color: "text.secondary", fontSize: 13.5 }}>
              Class 11 & 12 subject-wise PDFs.
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* Your existing component reused here */}
      {/* if you added id prop: <SyllabusSection id="syllabus-page" /> */}
      <SyllabusSection />
    </Box>
    <Footer />
    </>
  );
}
